export default __webpack_public_path__ + "static/media/important.81b7beb8.png";